var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('printSysContent',{attrs:{"printType":_vm.printType,"modelObj":_vm.modelObj,"member":'pagetmsWaybill',"modelClassName":_vm.modelClassName,"selectTableData":_vm.selectTableData,"dataSource":_vm.dataSource}})}
var staticRenderFns = []

export { render, staticRenderFns }